const OrdersManagementConstantsAr = {
  orderListMainTitle: 'إدارة الطلبات',
  orderAllStatus: 'الكل',
  orderPendingStatus: 'قيد الإنتظار',
  orderPaidStatus: 'مدفوع',
  orderFailedPaymentStatus: 'تعذر الدفع',
  orderDeliveredStatus: 'تم التسليم',
  orderCancelledStatus: 'ملغى',
  totalOrders: 'طلبات',
  totalMedia:'وسائط',
  orderTableOrderIdColumn: 'رقم الطلب',
  orderTableOrderCountColumn: 'عدد الوسائط',
  orderTableDateColumn: 'التاريخ',
  orderTableUserNameColumn: 'إسم المستخدم',
  orderTableStatusColumn: 'الحالة',
  orderDetailsMainTitle: 'مشاهدة الطلب',
  orderDetailsStatusSection: 'حالة الطلب',
  orderDetailsDeliveryDate: 'تاريخ التسليم المتوقع',
  orderDetailsUserDetailsSection: 'تفاصيل المستخدم',
  orderDetailsUserDetailsFirstName: 'الإسم الأول',
  orderDetailsUserDetailsLastName: 'الإسم الأخير',
  orderDetailsUserDetailsEmail: 'البريد الإلكتروني',
  orderDetailsUserDetailsCompanyName: 'إسم الشركة',
  orderDetailsPaymentMethodSection: 'طريقة الدفع',
  orderDetailsCreditCard: 'بطاقة إئتمان',
  orderDetailsWireTransfer: 'تحويل بنكي',
  orderDetailsVideosDetailsSection: 'تفاصيل الفيديوهات',
  orderDetailsUpdateButtonText: 'تحديث الطلب',

  orderDetailsDialogTableRightColumn: 'الحقوق',
  orderDetailsDialogTableExclusivityColumn: 'الحصرية',
  orderDetailsDialogTableHoldbackColumn: 'مدة الاحتجاز',
  orderDetailsDialogTableOneMonthOption: 'شهر',
  orderDetailsDialogTableThreeMonthOption: '3 أشهر',
  orderDetailsDialogTableSixMonthOption: '6 أشهر',
  orderDetailsDialogTableNineMonthOption: '9 أشهر',
  orderDetailsDialogOnlineDeliveryMethod: 'عبر الإنترنت',
  orderDetailsDialogOtherDeliveryMethod: 'أخرى',
  orderDetailsDialogCountries: 'الدول',
  orderDetailsDialogLicensePeriod: 'مدة الترخيص',
  orderDetailsDialogDeliveryMethod: 'طريقة التوصيل',
  orderDetailsDialogDeliveryDate: 'تاريخ التسليم',
  orderDetailsDialogChannels: 'منصات العرض',
  orderDetailsDialogNotes: 'الملاحظات',
  orderDetailsDialogTableExclusiveColumn: 'حصري',
  orderDetailsDialogTableNonExclusiveColumn: 'غير حصري',
  orderDetailsUpdatedSuccessfully: 'تم تحديث الطلب بنجاح',
  orderDetailsTotalPrice: 'المجموع الكلي',
  pickDate: 'حدد الوقت',
  orderPreparationStatus: 'قيد التجهيز',
};
export default OrdersManagementConstantsAr;
